<script setup>

</script>

<template>
    <div class="bg-[rgba(27,32,74,1)] rounded-lg px-6 py-2 after:absolute after:w-0 after:h-0 after:border-l-[10px] after:border-l-transparent after:border-t-[10px] after:border-t-[rgba(27,32,74,1)] after:border-r-[10px] after:border-r-transparent after:left-1/2 after:-translate-x-1/2 after:-bottom-[10px]">
        <slot />
    </div>
</template>
